import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {IconClose} from "../../Icon";
import {Button, Checkbox, ConfigProvider, message, Modal} from "antd";
import {t} from "i18next";
import {isStringNullOrEmpty} from "../../utils";
import {IMPORT_FILE_MODE_IMPORTMODE, MAX_Z_INDEX} from "../../Const";
import {ipcInvoke} from "../../common/ipc";
import {updateTranscript} from "@model/transcript";

const DialogEditTranscript = forwardRef((props:{onCloseCallback:any}, ref) => {
    useImperativeHandle(ref, () => ({
        onShowDialog: onShowDialog
    }))
    const [isShowDialog, setIsShowDialog] = useState(false);
    const [content,setContent] = useState('');
    const mCallback = useRef<any>(null);
    const mTranscript = useRef<any>(null);
    const txtInputRef = useRef(null);
    const mItem = useRef<any>(null);

    const onShowDialog = (transcript:any,item:any,callback:any)=>{
        setIsShowDialog(true);
        mCallback.current = callback;
        mTranscript.current = transcript;
        mItem.current = item;
        setContent(item?.content);

        setTimeout(()=>{
            txtInputRef.current?.focus();
            txtInputRef.current?.setSelectionRange(txtInputRef.current.value.length,txtInputRef.current.value.length);
        },200)
    }

    return <Modal width={520} zIndex={MAX_Z_INDEX} bodyStyle={{}}
                  styles={{
                      content: {
                          padding:'16px 16px'
                      }
                  }}
                  afterClose={() => {
                      props.onCloseCallback();
                  }}
                  open={isShowDialog} centered={true} closable={true} closeIcon={<IconClose/>} footer={null}
                  onCancel={() => {
                      setIsShowDialog(false)
                  }}>
        <div style={{height: '100%', width: '100%', display: 'flex', flexDirection: 'column'}}>
            <div className={'flex-row-vertical-center'} style={{flexShrink: '0'}}>
                <span className={'dialog-title'}>{t("Edit transcript")}</span>
                <div style={{flexGrow: '1'}}/>
            </div>
            <div className={'line mt-12'} style={{margin: '12px -22px'}}></div>

            <textarea ref={txtInputRef} className={'input-border'} style={{resize:'none',height:'160px',padding:'8px 10px',maxHeight:'126px',color:'var(--text-color)'}} defaultValue={content}>

            </textarea>

            <div className={'flex-center mt-32 mb-4'}>
                <Button
                    style={{height: '34px', minWidth: '120px'}}
                    className='large-w-button button-border-gray-style font-size-14 font-family-medium'
                    onClick={() => {
                        setIsShowDialog(false);
                    }}>{t("Cancel")}</Button>
                <Button
                    // disabled={isStringNullOrEmpty(selectFile)}
                    className='large-w-button button-solid-style font-size-14 font-family-medium'
                    type="primary"
                    onClick={async () => {
                        props.onCloseCallback();
                        //保存...
                        mItem.current.content = txtInputRef.current?.value;
                        const arrayData:any = [...mTranscript.current.data];
                        const nIndex = arrayData.findIndex(p=>p.id == mItem.current.id);
                        if (nIndex != -1) {
                            //替换这个...
                            arrayData.splice(nIndex,1,mItem.current);
                            mTranscript.current.data = arrayData;
                            //更新
                            await updateTranscript(mTranscript.current);

                            const newTransform = {...mTranscript.current};
                            mCallback.current(newTransform);
                        }
                    }}
                    style={{
                        marginLeft: '12px',
                        minWidth: '120px'
                    }}
                    htmlType={"submit"}>{t("Save")}</Button>
            </div>
        </div>
    </Modal>
})

export default DialogEditTranscript;